// @flow

import React from 'react';
import { colors } from 'seedling/constants';

type Props = {
  size: string,
};

function JobIcon({ size = '20' }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 5.5V4h4v1.5H8zm-1.5 0v-2a1 1 0 011-1h5a1 1 0 011 1v2H17a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1v-10a1 1 0 011-1h3.5zm0 10.5h-3V7h3v9zM8 16V7h4v9H8zm5.5 0h3V7h-3v9z"
        fill={colors.mediumGrey}
      />
    </svg>
  );
}

export default JobIcon;
